'use strict';

var angular = require('angular');
var dependencies = ['AVRO.ScheduleChange.WizardStep', 'AVRO.Common.FeatureToggle'];
module.exports = angular.module('AVRO.ScheduleChange.MarketWizard', dependencies).controller('MarketWizardController', require('./controllers/MarketWizardController')).directive('rmMarketWizard', require('./directives/MarketWizardDirective'));